import React from "react";
import styled from "styled-components";

import { ReactComponent as IconOrder } from "assets/images/map/icon-order.svg";
import { ReactComponent as IconRearrange } from "assets/images/map/icon-rearrange.svg";

const Self = styled.div`
  z-index: 1000;
  display: flex;
  fiex-direction: row;
  justify-content: center;
`;

const BottomButton = styled.div`
  margin: 0 4px;
  width: ${({ theme }) => theme.width90}px;
  height: 36px;
  border-radius: 10px;
  background-color: #fff;
  color: #212121;
  font-size: ${({ theme }) => theme.font16}px;
  font-weight: bold;
  letter-spacing: -0.32px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1.7px 4px 0 rgba(0, 0, 0, 0.2);
`;

const IconWrap = styled.span`
  display: inline-flex;
  width: 12px;
  margin-right: 5px;

  svg {
    width: 12px;
    height: auto;
    display: block;
  }
`;

const BottomButtons = ({ onClickStartOrder, onClickStartRearrange }) => {
  return (
    <Self>
      <BottomButton onClick={onClickStartOrder}>
        <IconWrap>
          <IconOrder />
        </IconWrap>
        순서
      </BottomButton>
      <BottomButton onClick={onClickStartRearrange}>
        <IconWrap>
          <IconRearrange />
        </IconWrap>
        배차
      </BottomButton>
    </Self>
  );
};

export default BottomButtons;
